import { Component, OnInit } from '@angular/core';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { FileDownloadService } from 'src/app/service/file-download/file-download.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  //get the current year for footer copy-rite
  year: Date = new Date();
  finalYear: any = this.year.getFullYear();

  constructor(
    private fileDownloadService: FileDownloadService,
    private alert: AlertServiceService ) {}

  downloadFile() {
    this.alert.showLoading();

    const fileUrl = 'assets/downloads/HP-SERVICE-LEVEL-E-AGREEMENT.docx'; // Adjust the path and filename
    this.fileDownloadService.downloadFile(fileUrl).subscribe((data) => {
      this.saveFile(data, 'HP-SERVICE-LEVEL-E-AGREEMENT.docx');
    });
  }

  private saveFile(data: Blob, filename: string) {
    const blob = new Blob([data], { type: data.type });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    this.alert.hideLoading("File already Downloaded")
  }

  ngOnInit(): void {}
}
